import * as React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'umi';
import isEmpty from 'lodash/isEmpty';

import { F, INTL_ENTITY } from '@/utils/intl';
import LeadDropdownFilter from '@/components/Filters/LeadDropdownFilter';
import * as LocationSelectors from '@/selectors/locationSelectors';
import { createOfferingRequest } from '@/services/api/location';

const OfferingSelect = (props: any) => {
  const offeringList = useSelector(LocationSelectors.selectOfferingList);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isEmpty(offeringList)) {
      dispatch({
        type: 'location/fetchOfferings',
      });
    }
  }, []);

  const handleSelectionChange = (offeringId, option) => {
    props.onChange && props.onChange(offeringId, option);
  };

  const handleCreateOffering = async (searchValue) => {
    try {
      const res = await createOfferingRequest({
        data: { name: searchValue },
      });
      dispatch({
        type: 'location/fetchOfferings',
      });
      props.onChange && props.onChange(res.data.uuid, res.data);
    } catch (error) {
      console.error('Failed to create offering:', error);
    }
  };

  return (
    <LeadDropdownFilter
      placeholder={
        <F
          id={'pages.leads.filters.offering.placeholder'}
          defaultMessage={'Category'}
        />
      }
      optionLabelKey={'name'}
      optionValueKey={'uuid'}
      filterKey={props.filterKey || 'offering_id'}
      options={offeringList}
      onCreate={handleCreateOffering}
      createEntity={INTL_ENTITY.OFFERING}
      {...props}
      onChange={handleSelectionChange}
    />
  );
};

export default OfferingSelect;
